import React from 'react';
import { DashboardFilters } from './../../StartPage/Dashboard/components/DashboardFilters';
import { FormattedMessage, injectIntl } from 'react-intl';
import DisabledEntitiesFilter from './DisabledEntities.filter';
import FilterPod from './../../../reusable/Filters/FilterPod.jsx';

class EntityDashboardFilters extends DashboardFilters {
    static propTypes = DashboardFilters.propTypes;
    static defaultProps = DashboardFilters.defaultProps;

    constructor(props) {
        super(props);

        // removing the handlers for entities
        this.changeHandlers = {
            ...this.changeHandlers,
            entities: () => {}
        }
        this.resetHandlers = {
            ...this.resetHandlers,
            entities: () => {}
        }
    }

    renderEntitiesFilter() {
        return <FilterPod title={<FormattedMessage id={"RSS_Feed_UIText_feedListing.entities"} />}
                          isOpen={!this.props.filtersCollapsed.filtersEntities}
                          className='entities-filter disabled'
                          reset={<FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.reset"/>}
                          resetHandler={this.resetHandlers.entities}
                          onToggleVisibility={this.toggleFilterCollapsed('filtersEntities')}>
            <DisabledEntitiesFilter entitiesSelection={this.state.filters.entities} entities={this.state.entities}/>
        </FilterPod>;
    }
}

export default injectIntl(EntityDashboardFilters);


// WEBPACK FOOTER //
// ./src/scripts/pages/EntityDashboard/components/EntityDashboardFilters.jsx